import { getAuthState } from './auth';

export const isRanByCypress = () => {
  return getAuthState().isRanByCypress;
};
